const initState = {
    isFetching: false
}

const customerReducer = (state = initState, action) => {
    switch (action.type) {
        case 'GET_CUSTOMER':
            return action.data;      

        case 'GET_CUSTOMER_FAILED':
            return action.data;    

        case 'DELETE_CUSTOMER':
            return action.data;      

        case 'DELETE_CUSTOMER_FAILED':
            return action.data;    

        case 'CREATING_CUSTOMER':
            return {
                ...action.data, 
                isFetching: true
            };

        case 'CREATE_CUSTOMER':
            return {
                ...action.data, 
                isFetching: false
            };

        case 'CREATE_CUSTOMER_FAILED':
            return {
                ...action.data, 
                isFetching: false
            };

        case 'UPDATING_CUSTOMER':
            return {
                ...action.data, 
                isFetching: true
            };

        case 'UPDATE_CUSTOMER':
            return {
                ...action.data, 
                isFetching: false
            };

        case 'UPDATE_CUSTOMER_FAILED':
            return {
                ...action.data, 
                isFetching: false
            };         

        default:
            return state;
    }
}

export default customerReducer;